import React, { useState } from 'react';
import { addYears, format, parseISO } from 'date-fns';

import { FaCalendarAlt } from 'react-icons/fa';

import { Popover, OverlayTrigger, Badge } from 'react-bootstrap';

import { startOfToday } from 'date-fns/esm';
import Modal from '../../Modal';

import { ButtonAgendamentos, VerHistorico } from './styles';
import Historico from '../../Historico';

interface IAgendamentosPaciente {
  AgeCodigo: number;
  AgeInicio: Date;
  AgeFim: Date;
  AgeStatus: number;
  ConNome: string;
}

type AgendamentoProps = {
  PacCodigo: number;
  PacNome?: string;
  agendamentos: IAgendamentosPaciente[];
  atendimentos: number;
  faltas?: number;
};

const Agendamento: React.FC<AgendamentoProps> = ({
  PacCodigo,
  PacNome,
  agendamentos,
  atendimentos,
  faltas,
}) => {
  const [showModalAtendimentos, setShowModalAtendimentos] = useState(false);
  const [parametroData, setParametroData] = useState(() => {
    if (faltas && faltas > 0) {
      const hoje = startOfToday();
      return `&data=${format(
        addYears(hoje, -1),
        'yyyy-MM-dd',
      )}&datafim=${format(hoje, 'yyyy-MM-dd')}`;
    }
    return '';
  });
  const popover = (
    <Popover id="agendamentosPac">
      <Popover.Title as="h5">Agendamentos futuros</Popover.Title>
      <Popover.Content>
        {agendamentos.map(age => (
          <div
            key={age.AgeCodigo.toString()}
            className="border rounded p-2 small"
          >
            {`${age.ConNome} - ${format(
              parseISO(age.AgeInicio.toString()),
              'dd/MM/yyyy HH:mm',
            )} - ${format(parseISO(age.AgeFim.toString()), 'HH:mm')}`}
          </div>
        ))}
      </Popover.Content>
    </Popover>
  );

  return (
    <>
      {showModalAtendimentos && (
        <Modal
          show={showModalAtendimentos}
          titulo="Histórico do Paciente"
          handleFecharModal={() => setShowModalAtendimentos(false)}
          large
        >
          <Historico pacCodigo={PacCodigo} />
        </Modal>
      )}
      <div className="d-flex justify-content-between align-items-center">
        <span>
          Nº de Atendimentos: {atendimentos} -{' '}
          <Badge
            className="badge-light"
            onClick={() => setShowModalAtendimentos(true)}
          >
            <VerHistorico>Ver</VerHistorico>
          </Badge>
        </span>
        {faltas && faltas > 0 && (
          <span
            className={faltas > 2 ? 'badge badge-pill badge-danger' : ''}
            style={{ fontSize: '.8rem' }}
          >
            Nº de Faltas: {faltas}{' '}
            <a
              href={`/agendabusca?status=-1&paciente=${
                PacNome || ''
              }${parametroData}`}
              className="text-white"
              rel="noreferrer"
              target="_blank"
            >
              Ver
            </a>
          </span>
        )}

        <div>
          {agendamentos && agendamentos.length > 0 && (
            <OverlayTrigger trigger="click" placement="left" overlay={popover}>
              <ButtonAgendamentos type="button">
                <FaCalendarAlt />
              </ButtonAgendamentos>
            </OverlayTrigger>
          )}
        </div>
      </div>
    </>
  );
};

export default Agendamento;
